<template>
  <div>
    <div :style="isTabletLandscapeUp ? { display: 'flex', justifyContent: 'space-between' } : {}">
      <div
        :style="{
          width: '100%',
          backgroundImage: isTabletLandscapeUp ? `url(${require('@/images/promotion.png')})` : ''
        }">
        <Container
          :style="{
            width: isTabletLandscapeUp ? '50%' : '100%',
            paddingRight: isTabletLandscapeUp ? '40px' : '',
            paddingLeft: isTabletLandscapeUp ? '40px' : '',
            marginLeft: isTabletLandscapeUp ? '51%' : ''
          }"
        >
          <FormRow>
            <div style="display: flex; justify-content: space-between;">
              <ChosenButton
                :chosen="donationPeriod === donationPeriodType.DONATION_PERIOD"
                @click.native="choseType(donationPeriodType.DONATION_PERIOD)"
              >
                {{ donationPeriodType.DONATION_PERIOD }}
              </ChosenButton>
              <ChosenButton
                :chosen="donationPeriod === donationPeriodType.DONATION_SINGLE"
                @click.native="choseType(donationPeriodType.DONATION_SINGLE)"
              >
                {{ donationPeriodType.DONATION_SINGLE }}
              </ChosenButton>
            </div>
          </FormRow>

          <br>

          <Form>
            <FormCard>
              <BreadCrumb :items="breadCrumbitems" />
              <FormHeading>
                    {{ steps.DONATION_AMOUNT }}
                <span v-if="donationAmount">$ {{ donationAmount }}</span>
              </FormHeading>

              <FormRow
                v-if="donationPeriod == donationPeriodType.DONATION_SINGLE"
              >
                <div class="btn-wrap">
                  <ChosenButton
                    :chosen="donationAmount == '500'"
                    @click.native="choseAmount('500')"
                  >
                    $500
                  </ChosenButton>
                  <ChosenButton
                    :chosen="donationAmount == '2000'"
                    @click.native="choseAmount('2000')"
                  >
                    $2000
                  </ChosenButton>
                  <ChosenButton
                    :chosen="donationAmount == '3000'"
                    @click.native="choseAmount('3000')"
                  >
                    $3000
                  </ChosenButton>
                  <ChosenButton
                    :chosen="donationAmount == '5000'"
                    @click.native="choseAmount('5000')"
                  >
                    $5000
                  </ChosenButton>
                </div>
              </FormRow>

              <FormRow
                v-if="donationPeriod == donationPeriodType.DONATION_PERIOD"
              >
                <div class="btn-wrap">
                  <ChosenButton
                    :chosen="donationAmount == '500'"
                    @click.native="choseAmount('500')"
                  >
                    $500
                  </ChosenButton>
                  <ChosenButton
                    :chosen="donationAmount == '800'"
                    @click.native="choseAmount('800')"
                  >
                    $800
                  </ChosenButton>
                  <ChosenButton
                    :chosen="donationAmount == '1000'"
                    @click.native="choseAmount('1000')"
                  >
                    $1000
                  </ChosenButton>
                  <ChosenButton
                    :chosen="donationAmount == '2000'"
                    @click.native="choseAmount('2000')"
                  >
                    $2000
                  </ChosenButton>
                </div>
              </FormRow>

              <FormRow>
                <template>
                  <FormLabel for="donation-amount">
                    自行輸入捐款金額
                  </FormLabel>
                  <TextInput
                    id="donation-amount"
                    data-testid="donation-amount"
                    placeholder="請輸入台幣金額"
                    :value.sync="donationAmount"
                    :error="donationAmountError"
                  />
                </template>
              </FormRow>

              <FormRow v-if="donationPeriod == donationPeriodType.DONATION_SINGLE">
                <template>
                  <FormLabel for="donation-way">
                    捐款方式
                  </FormLabel>
                  <SelectInput
                    id="donation-way"
                    :options="
                      [
                        donationWayType.ECPAY_SINGLE_CREDIT,
                        donationWayType.ECPAY_SINGLE_ATM,
                        donationWayType.ECPAY_SINGLE_CVS,
                        donationWayType.LINEPAY_SINGLE,
                        donationWayType.JKOPAY_SINGLE,
                      ]"
                    :value.sync="donationWay"
                    :error="donationWayError"
                  />
                </template>
              </FormRow>

              <FormRow v-if="donationPeriod == donationPeriodType.DONATION_PERIOD">
                <template>
                  <FormLabel for="donation-way">
                    捐款方式
                  </FormLabel>

                  <p style="font-size: 16px; color: #666;">
                    {{ donationWayType.ECPAY_PERIOD_CREDIT }}
                  </p>
                </template>
              </FormRow>

              <br>
              <Align right>
                <Button
                  :small="isMobile"
                  @click.native="submit()"
                >
                  下一步
                </Button>
              </Align>
            </FormCard>
          </Form>
        </Container>
      </div>

      <div v-if="!isTabletLandscapeUp" style="width: 100%;">
        <img src="@/images/promotion-phone.png" alt="Sample Image" style="width: 100%;">
      </div>
    </div>
    <h2 :style="isTabletLandscapeUp ? { fontSize: '30px' } : {fontSize: '25px'}" style="font-weight: bold; margin-bottom: 10px; color:#e72774;">捐款人分享</h2>
    <div
      :style="isTabletLandscapeUp ? {
        display: 'flex',
        justifyContent: 'center',
        gap: '20px',
        marginTop: '30px',
        fontSize: '16px'
      } : {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        marginTop: '30px',
        padding: '0 20px',
        fontSize: '14px'
      }">
      <div
        :style="isTabletLandscapeUp ? {
          flex: 1,
          maxWidth: '25%'
        } : {
          width: '100%'
        }"
        style="background-color: #eee; padding: 20px; border-radius: 5px; box-shadow: 2px 2px 7px rgba(0, 0, 0, 0.3);">
        <p style="text-align: left; line-height: 1.8;">
          雖然在我成長經驗中，父母無法時常陪伴於身邊，但是我很幸運，都遇到很多很好的老師。
          我相信如果孩子可以遇到一個好的老師，就有機會可以翻轉未來，所以這是為什麼我會一直支持 TFT。
        </p>
        <p style="text-align: right; line-height: 30px;">
          <img
            src="@/images/icons/cheng_icon.png"
            style="width: 25px; height: 25px; vertical-align: text-bottom;">
          張小姐，屏東人
        </p>
      </div>

      <div 
        :style="isTabletLandscapeUp ? {
          flex: 1,
          maxWidth: '25%'
        } : {
          width: '100%'
        }"
        style="
          background-color: #eee;
          padding: 20px;
          border-radius: 5px;
          box-shadow: 2px 2px 7px rgba(0, 0, 0, 0.3);
        ">
        <p style="text-align: left; line-height: 1.8; ">
          我出身於偏鄉，會想要讓偏鄉的小朋友們，能夠更快速、更直接的接觸到這個世界，讓他們知道世界是很廣闊的，原來人生可以那麼豐富、精彩。
          期待他們未來在外，累積了視野與知識後，再將經驗與想法回饋家鄉。
        </p>
        <p style="text-align: right; line-height: 30px;">
          <img src="@/images/icons/xu_icon.png" style="width: 25px; height: 25px; vertical-align: text-bottom;">
          徐先生，苗栗人
        </p>
      </div>

      <div 
        :style="isTabletLandscapeUp ? {
          flex: 1,
          maxWidth: '25%'
        } : {
          width: '100%'
        }"
        style="
          background-color: #eee;
          padding: 20px;
          border-radius: 5px;
          box-shadow: 2px 2px 7px rgba(0, 0, 0, 0.3);
        ">
        <p style="text-align: left; line-height: 1.8;">
          我有小孩，
          我覺得小孩的教養很重要，
          而台灣的教育環境有很多問題，
          需要有人去改變，
          TFT 做的項目很特別、很深，
          在做的就是一些很重要的改變。
        </p>
        <p style="text-align: right; line-height: 30px;">
          <img src="@/images/icons/lee_icon.png" style="width: 25px; height: 25px; vertical-align: text-bottom;">
          李先生，台北人
        </p>
      </div>
    </div>

    <div :style="isTabletLandscapeUp ? { padding: '70px 100px' }: {}">
      <h2 
        :style="isTabletLandscapeUp ? { fontSize: '30px' } : { fontSize: '25px' }"
        style="
          font-weight: bold;
          margin-top: 30px;
          margin-bottom: 10px;
          color: #e72774;
        "
      >
        資金用途
      </h2>
      <br>
      <div
        :style="isTabletLandscapeUp ? {
          display: 'flex',
          justifyContent: 'center'
        } : {}">
        <div v-if="isTabletLandscapeUp">
          <img
            src="@/images/chart.png"
            alt="圖表顯示捐款分配"
            style="width: 90%;"
          >
        </div>

        <div
          :style="{
            width: '100%',
          }"
          style="
            padding: 20px;
            padding-top: 40px;
            margin-right: 30px;
            text-align: left;
          "
        >
          <h2 
            :style="isTabletLandscapeUp ? { fontSize: '24px' } : { fontSize: '20px' }"
            style="
              font-weight: bold;
              margin-bottom: 10px;
            "
          >
            將資源忠實地運用，朝願景邁進。
          </h2>
          <hr style="margin: 20px 0; width: 40%;">
          <p
            :style="isTabletLandscapeUp ? { fontSize: '16px' } : { fontSize: '14px' }"
            style="line-height: 1.5;"
          >
            TFT 為非營利組織，資金收入 100% 來自組織、個人捐贈及其他非以營利為目的之收入。為了穩定營運與發展 TFT 計畫與多元回應議題方案，確保孩子的受教權益，TFT 提前募集所需的資金，確保組織財務的穩健，讓影響力得以發生。
          </p>
          <p
            :style="isTabletLandscapeUp ? { fontSize: '16px' } : { fontSize: '14px' }"
            style="line-height: 1.5;"
          >
            除了依法規要求之會計年度查核之外，為使大眾能有效理解財務規劃及運用，TFT 額外委任會計師進行學年度查核，並個別出具財務報表，以負責任的方式呈現組織對每一份資源妥善使用。
            <br>
            <br>
            <a
              href="https://www.teach4taiwan.org/finance/"
              target="_blank"
              style="color: #e73273"
            >
              了解 TFT 財務報告
            </a>
          </p>
        </div>
      </div>

      <div v-if="!isTabletLandscapeUp" style="width: '50%'; padding: 20px;">
        <img src="@/images/chart.png" alt="圖表顯示捐款分配" style="width: 100%;">
      </div>
    </div>

    <div :style="{ width: isTabletLandscapeUp ?  '60%' : '90%' }"  style="text-align: center; margin: auto;">
      <h2 :style="isTabletLandscapeUp ? { fontSize: '30px' } : {fontSize: '25px'}" style="font-weight: bold; margin-bottom: 10px; color:#E72774">捐款相關疑問</h2>
      <br>
      <toggleItem
        title="除線上捐款，是否還有其他捐款方式？"
        content="有的，除了線上捐款，也可以透過<a style='color: #e73273' href='https://shopee.tw/teach4taiwan' target='_blank'>蝦皮</a>、<a style='color: #e73273' href='https://service.jkopay.com/r/aweb?url=https%3A%2F%2Fdonation-app.jkos.com%2Fcharity-group%2F2' target='_blank'>街口支付</a>、<a style='color: #e73273' href='https://web-tw-pay.line.me/cms/donation/63c7ff482c7f4dfb88261bf1d9c1a844' target='_blank'>LINEPay</a> 與下列方式捐款支持。<br><br>【台幣轉帳】<br>請依下列資訊進行轉帳，並於轉帳完將收據開立資訊（收據抬頭姓名、身分證字號或公司統編、聯絡電話、電子信箱）寄到 fin@teach4taiwan.org。<br>若有紙本收據需求，除上述資訊外，也邀請您一併提供收據寄件地址與收件人資訊。<br><br>戶名｜財團法人為台灣而教教育基金會<br>匯款銀行｜國泰世華銀行忠孝分行 (013)<br>匯款帳戶｜011035009622<br><br>【郵政劃撥】<br>請至郵局索取劃撥單，並詳細填寫捐款人聯絡資料，完成劃撥。<br><br>戶名｜財團法人為台灣而教教育基金會<br>劃撥帳號｜50394835<br><br>【支票匯款】<br>請將支票寄送到 TFT 辦公室，並請於背面註明禁止背書轉讓。<br><br>受款人｜財團法人為台灣而教教育基金會<br>支票寄送地址｜10043 台北市中正區寶慶路 25 號 2 樓 TFT 財務收"
      />

      <toggleItem
        title="是否有外幣、國外捐款管道？"
        content="【非台幣轉帳】<br>請用以下資訊進行轉帳：<br><br>Beneficiary’s Name｜TEACH FOR TAIWAN<br>A/C with Bank｜CATHAY UNITED BANK, TAIPEI, TAIWAN（國泰世華商業銀行）<br>7 SONGREN ROAD, XINYI DISTRICT, TAIPEI, TAIWAN（台北市信義區松仁路7號）<br>Account No.｜011087069003<br>Swift Code｜UWCBTWTP<br>Beneficiary’s Telephone No.｜+886 (02)-2345-6225<br>Email Address｜fin@teach4taiwan.org<br><br>【美國收據】<br>透過「世台聯合基金會(STUF UnitedFundInc.)」捐款，世台為在美國登記成立之非營利慈善機構，為美國聯邦政府核可之 501(c)(3) 組織。由世台基金會開立的捐贈收據，在美國可依法扣抵聯邦所得稅。<br><br>透過「世台聯合基金會(STUF UnitedFundInc.)」捐款——支票<br>請列印填寫 「Pledge Form」，完成填寫此表後，連同支票寄給「世台聯合基金會」。<br>支票抬頭｜STUF United Fund Inc.<br>支票備註｜支票中須備註指名捐贈 Donor-designated fund – Teach For Taiwan<br>郵寄地址｜STUF United Fund P.O. Box 520511 Flushing, NY 11352<br><br>透過「世台聯合基金會(STUF UnitedFundInc.)」捐款——匯款<br>捐款者若以匯款的方式捐贈，請先行聯繫世台基金會 黃怡妙 總幹事，世台基金會將提供詳細匯款資訊給您。捐款時請指名捐贈「Donor-designated fund – Teach For Taiwan」。<br><br>黃總幹事（Yi-Miao Huang）聯絡資訊：<br>Tel｜914-433-0415<br>Email｜yimiao@stufunited.org"
      />

      <toggleItem
        title="如何知道當次捐款有沒有成功？"
        content="若捐款成功，捐款系統將顯示「捐款成功」畫面。<br>如有任何問題歡迎寄電子郵件至 fin@teach4taiwan.org 詢問。"
      />

      <toggleItem
        title="完成捐款後，想調整捐款金額、更換信用卡或停止捐款怎麼辦？"
        content="如有以下需求：<br>・修改定期定額捐款資料（更改信用卡卡號、調整捐款金額、暫停捐款）<br>・沒收到或需要提早取得年度紙本收據（通常於每年 4 月底前寄出）<br><br>請寄電子郵件至 fin@teach4taiwan.org，說明您的需求並提供以下資訊，供我們確認查詢您的紀錄：<br>・捐款姓名<br>・聯絡資訊（手機、Email、收據寄送地址）<br>・捐款方式（線上捐款、郵政劃撥、每月定期定額、匯款：請提供匯款帳號末五碼）<br>・捐款金額"
      />

      <toggleItem
        title="捐款給 TFT 是否可以抵稅？"
        content="可以，您的捐款可在下一年度綜所稅報稅時列舉扣除。<br><br>TFT 已向國稅局申請「捐贈扣除額單據電子化」，因此只要您捐款時確實填寫「身分證字號」，申報列舉扣除時將不需要再檢附紙本贊助收據；您也可選擇以紙本實體收據申報，定期定額捐款則以年度收據的方式開立，並於每年二月結算後寄出。<br><br>若您是透過非 TFT 官網平台捐款（例如：蝦皮、街口、linepay、郵政劃撥等），並且選擇單筆紙本收據，財務會在 隔月的 20 號前完成寄出。例如：捐款人於 10 月捐款，財務會於 11/20 前掛號寄出單筆紙本收據予捐款人"
      />

     <toggleItem
        title="若是代表企業/基金會，想捐款支持或合作，可以如何接洽？"
        content="邀請您前往 <a style='color: #e73273' href='https://www.teach4taiwan.org/about/sponsor-partner/' target='_blank'>成為企業 / 基金會支持夥伴</a> 頁面了解更多。"
      />
     <toggleItem
        title="我已是 TFT 捐款者，需要查詢捐款紀錄、重新申請電子收據，可以如何處理？"
        content="若需重新索取電子收據，可登入「<a style='color: #e73273' href='https://donation.teach4taiwan.org/search' target='_blank'>TFT 捐款紀錄查詢</a>」申請補發。"
      />
    </div>

    <div>
      <br>
      <h2 :style="isTabletLandscapeUp ? { fontSize: '30px' } : {fontSize: '25px'}" style="font-weight: bold; margin-bottom: 10px; color:#E72774">了解更多</h2>
      <br>
      <div :style="isTabletLandscapeUp ? { display: 'flex', justifyContent: 'space-between', width:'63%', margin: 'auto', marginBottom: '40px'} : {marginBottom: '40px'}">
        <div style="padding: 10px;">
          <a href="https://www.teach4taiwan.org/about/sponsor-partner/" style="text-decoration: none; cursor: pointer;" target="_blank">
            <div :style="{ width: isTabletLandscapeUp ?  '250px' : '80%' ,margin: 'auto' }">
              <img 
                style="width: 100%"
                src="@/images/bottom1.jpg" 
                alt="企業合作">
              <div style="background-color: #e73273; font-size: 20px; color: white;">企業合作 ➔</div>
            </div>
          </a>
        </div>
        <div style="padding: 10px;">
          <a href="https://www.teach4taiwan.org/challenge/stories/" style="text-decoration: none; cursor: pointer;" target="_blank">
            <div :style="{ width: isTabletLandscapeUp ?  '250px' : '80%' ,margin: 'auto' }">
              <img 
                style="width: 100%"
                src="@/images/bottom2.jpg" 
                alt="TFT 故事棧">
              <div style="background-color: #e73273; font-size: 20px; color: white;">TFT 故事棧 ➔</div>
            </div>
          </a>
        </div>
        <div style="padding: 10px;">
          <a href="https://www.teach4taiwan.org/about/" style="text-decoration: none; cursor: pointer;" target="_blank">
            <div :style="{ width: isTabletLandscapeUp ?  '250px' : '80%' ,margin: 'auto' }">
              <img 
                style="width: 100%"
                src="@/images/bottom3.jpg" 
                alt="關於我們">
              <div style="background-color: #e73273; font-size: 20px; color: white;">關於我們 ➔</div>
            </div>
          </a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
// configs
import steps from '@/configs/steps';
import {
  clear as clearStorage,
} from '@/lib/storage';

import donationPeriodType from '@/configs/donationPeriod';
import donationWayType from '@/configs/donationWay';
import { isValidString, isValidAmount, isValidOption } from '../../utilities/validators';
import { DONATION_WAY_TO_DONATION_GA_INFO } from '@/configs/GAconfig.js';
import { saveStore } from '@/lib/storage';
import IconArrowDown from '@/images/icons/arrow-down.svg';

import Container from '../../components/layout/Container';
import Align from '../../components/layout/Align';
import Title from '../../components/Title';
import Form from '../../components/form/Form';
import FormCard from '../../components/form/FormCard';
import FormHeading from '../../components/form/FormHeading';
import FormLabel from '../../components/form/FormLabel';
import FormRow from '../../components/form/FormRow';

import Button from '../../components/buttons/Button';
import ChosenButton from '../../components/buttons/ChosenButton';

import TextInput from '../../components/inputs/TextInput';
import SelectInput from '../../components/inputs/SelectInput';

import BreadCrumb from '../../components/others/BreadCrumb';
import ToggleItem from '../../components/others/ToggleItem';

export default {
  components: {
    Container,
    Align,

    Title,

    Form,
    FormCard,
    FormHeading,
    FormRow,
    FormLabel,

    ChosenButton,
    Button,

    TextInput,
    SelectInput,

    BreadCrumb,

    IconArrowDown,
    ToggleItem,
  },

  data() {
    return {
      steps: Object.freeze(steps),
      donationPeriodType: Object.freeze(donationPeriodType),
      donationWayType: Object.freeze(donationWayType),
      donationAmountError: '',
      donationWayError: '',
    };
  },

  computed: {
    ...mapState({
      breadCrumbitems: state => state.breadCrumb.items,
    }),

    ...mapFields('donation', {
      donationPeriod: 'donationPeriod',
      donationWay: 'donationWay',
      donationAmount: 'amount',
      campaignId: 'campaignId',
    }),

    ...mapGetters('ui', [
      'isMobile',
      'isTabletLandscapeUp'
    ]),

    valid() {
      return !this.donationAmountError && !this.donationWayError;
    },

  },

  mounted() {
    this.updateStep('0');
    this.donationPeriod = this.getDonationPeriod();
    this.getCampaignId();
    this.getDonationAmount();
    this.donationWay = this.donationPeriod == donationPeriodType.DONATION_PERIOD ? '信用卡定期定額' : '';
  },

  methods: {
    ...mapMutations({
      updateStep: 'breadCrumb/updateStep',
      resetFields: 'donation/resetFields',
    }),

    ...mapActions('donation', [
      'validateCampaignId',
    ]),

    async getCampaignId() {
      const campaignId = this.$route.query.campaignId;
      const validate = campaignId ? await this.validateCampaignId(campaignId) : false;
      this.campaignId = validate ? campaignId : '';
    },

    async getDonationAmount() {
      const amountFromRoute = this.$route.query.defaultAmount;
      if (amountFromRoute) {
        this.donationAmount = amountFromRoute;
      }
    },

    checkForErrors() {
      if (!isValidString(this.donationAmount)) {
        this.donationAmountError = '請輸入捐款金額，並且不要使用全形符號、空格、或,+!?/()等符號。';
      }
      else if (!isValidAmount(this.donationAmount)) {
        this.donationAmountError = '請輸入正確的捐款金額';
      }
      else if (Number(this.donationAmount) < 100) {
        this.donationAmountError = '捐款金額需至少100元';
      }
      else if (this.donationWay == '信用卡單次繳款' && this.donationAmount > 200000) {
        this.donationAmountError = '信用卡付款單次捐款金額上限為 20 萬元，若欲捐款 20 萬元以上，建議分次填寫或採用其他捐款方式，謝謝！';
      }
      else if (this.donationWay == 'ATM轉帳繳款' && this.donationAmount > 200000) {
        this.donationAmountError = 'ATM 轉帳繳款單次捐款上限為 20 萬元，若欲捐款 20 萬元以上，建議分次填寫或採用其他捐款方式，謝謝！';
      }
      else if (this.donationWay == '超商代碼繳款' && this.donationAmount > 20000) {
        this.donationAmountError = '超商代碼繳款單次捐款上限為 2 萬元，若欲捐款 2 萬元以上，建議分次填寫或採用其他捐款方式，謝謝！';
      }
      else {
        this.donationAmountError = null;
      }

      if(this.donationPeriod === donationPeriodType.DONATION_SINGLE) {
        if(!isValidOption(this.donationWay)) {
          this.donationWayError = '請選擇捐款方式';
        }
        else {
          this.donationWayError = null;
        }
      }

    },

    // 當使用者直接從特定的url近來，會需要從url判斷捐款類型
    getDonationPeriod() {
      if (this.$route.name == 'period-amount') {
        return donationPeriodType.DONATION_PERIOD;
      } else if (this.$route.name == 'single-amount') {
        return donationPeriodType.DONATION_SINGLE;
      } else {
        return donationPeriodType.DONATION_PERIOD;
      }
    },

    back() {
      this.$router.push({ name: 'donation-way' });
    },

    sendGA() {
      const GA_DONATION_INFO = DONATION_WAY_TO_DONATION_GA_INFO[this.donationWay];
      const GA_PARM = {
        ecommerce: {
          currency: 'TWD',
          value: this.donationAmount,
          items: [GA_DONATION_INFO['item']],
        },
      };
      this.$gtag.event('TD_add_to_cart', GA_PARM);
      console.log('TD_add_to_cart', GA_PARM);
    },

    submit() {
      saveStore();
      this.checkForErrors();
      if(this.valid) {

        this.sendGA();
        this.$router.push({ name: this.donationPeriod === donationPeriodType.DONATION_SINGLE ? 'single-info' : 'period-info' });
      }
    },

    choseType(data) {
      clearStorage();
      this.resetFields();
      this.donationPeriod = data;
      this.donationWay = data == donationPeriodType.DONATION_PERIOD ? '信用卡定期定額' : '';
    },

    choseAmount(data) {
      this.donationAmount = data;
    },
  },
};

</script>

<style lang="scss">
.btn-wrap {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  > button {
    margin: 5px 0;
  }
}

.text {
  font-size: 1.4rem;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.75;
  letter-spacing: 0.8px;
  color: $color-text;
  margin: 10px auto 10px;
}
</style>

<style lang="scss" module>
.promotion {
  display: flex;
  justify-content: space-between;
}

.text {
  font-size: 1.2rem;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.75;
  letter-spacing: 0.8px;
  color: $color-text;
  margin: 10px auto 10px;
}
</style>

